// @ts-strict-ignore
import {Directive, ElementRef, Injector, OnInit} from "@angular/core";
import {BreakpointObserver} from "@angular/cdk/layout";
import {DialogPosition, MAT_DIALOG_DATA, MatDialogConfig, MatDialogRef} from "@angular/material/dialog";
import {Translations} from "@translations";

export interface MatDialogDataBaseInput {
	width?: number;
	target?: ElementRef;
	align?: "left" | "bottom" | "top" | "right";
}

export interface MatDialogDataBaseOutput {
	action: "ok" | "cancel" | "close" | "replaceAll";
}

export const DIALOG_HEIGHT_CLASSES: string[] = ["matDialogFixedHeight90vh", "matDialogFixedHeight80vh"];

@Directive()
export abstract class BasicMaterialDialog<
	DialogTemplateComponent,
	DialogInputData extends MatDialogDataBaseInput = MatDialogDataBaseInput,
	DialogOutputData extends MatDialogDataBaseOutput = MatDialogDataBaseOutput,
> implements OnInit
{
	public readonly observer: BreakpointObserver;
	public readonly data: DialogInputData;
	protected readonly dialogRef: MatDialogRef<DialogTemplateComponent, DialogOutputData>;
	private readonly triggerElementRef: ElementRef;

	T = Translations;
	finished: boolean = false;
	matDialogConfig: MatDialogConfig = new MatDialogConfig();
	rect: DOMRect;

	protected constructor(_injector: Injector) {
		this.data = _injector.get<DialogInputData>(MAT_DIALOG_DATA);
		this.dialogRef = _injector.get(MatDialogRef) as MatDialogRef<DialogTemplateComponent, DialogOutputData>;
		this.observer = _injector.get(BreakpointObserver);
		this.triggerElementRef = this.data.target;

		this.dialogRef.afterOpened().subscribe(() => {
			this.finished = true;
		});
	}

	ngOnInit(): void {
		if (!!this.data.target) {
			this.initPosition();
		} else if (this.data.align === "left") {
			this.initPositionTwoScreen();
		}
	}

	public close(params?: DialogOutputData): void {
		!!params ? this.dialogRef.close(params) : this.dialogRef.close(<DialogOutputData>{action: "close"});
	}

	private initPosition(): void {
		this.rect = this.triggerElementRef.nativeElement.getBoundingClientRect();
		switch (this.data.align) {
			// set dialog position
			case "top":
				this.matDialogConfig.position = {
					left: `${this.rect.left}px`,
					bottom: `${this.rect.bottom}px`,
				} as DialogPosition;
				break;
			case "right":
				this.matDialogConfig.position = {
					left: `${this.rect.right + 10}px`,
					top: `${this.rect.bottom - this.rect.height}px`,
				} as DialogPosition;
				break;
			case "left":
				this.matDialogConfig.position = {
					left: `${this.rect.left - this.data.width - 10}px`,
					top: `${this.rect.bottom - this.rect.height}px`,
				} as DialogPosition;
				break;
			case "bottom":
				this.matDialogConfig.position = {
					left: `${this.rect.left}px`,
					top: `${this.rect.bottom}px`,
				} as DialogPosition;
		}
		this.matDialogConfig.width = this.data.width + "px";
		this.dialogRef.updateSize(this.matDialogConfig.width, this.matDialogConfig.height);
		this.dialogRef.updatePosition(this.matDialogConfig.position);
	}

	private initPositionTwoScreen(): void {
		const isTwoScreen: boolean = !this.observer.isMatched("(max-width: 1920px)");
		if (isTwoScreen) {
			const left: number = 2880 - this.data.width / 2;
			this.matDialogConfig.position = {left: left + "px"};
			this.dialogRef.updatePosition(this.matDialogConfig.position);
		}
	}

	protected toggleDialogHeight() {}
}
